export default "__VITE_ASSET__DZlnvb5A__"